import { createClient } from '@supabase/supabase-js';

/**
 * @description Supabase client with anonymous key. Can only access public data!
 */
export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
);
